import { render, staticRenderFns } from "./index.vue?vue&type=template&id=694dd406"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=694dd406&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/eazyads-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694dd406')) {
      api.createRecord('694dd406', component.options)
    } else {
      api.reload('694dd406', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=694dd406", function () {
      api.rerender('694dd406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/youtube/index.vue"
export default component.exports